module.exports = __webpack_public_path__ + "static/media/gbgh-logo-tablet.98aefb67.svg";